import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import EditPackageDrawer from "../../../components/EditPackageDrawer";
import html2canvas from "html2canvas";
import edit from "../../../assets/svg/edit.svg";
import slip from "../../../assets/svg/slip.svg";
import arrow from "../../../assets/svg/arrow-down-circle.svg";
import CustomTable from "../../../components/CustomTable";
import { format, fromUnixTime } from "date-fns";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import SelectionTag from "../../../components/SelectionTag";
import SimpleBar from "simplebar-react";
import { toast } from "react-toastify";
import { calculateTotalValues } from "../shippingRequest/helper";
import Slip from "./Slip";
import AccordionViaTableRowName from '../../../components/AccordionViaTableRowName'
// import { availableSerialNumber, updateSerialNumber } from "./helper";
// import { getShipmentDetails } from "../pages/Shipping/Integration/APIService";
// import { useSelector } from "react-redux";
import { db } from "../../../firebaseConfig";
import { useSelector } from "react-redux";

function PackageTraking({
  // packageActiveData = {},
  packageClickHandler,
  selectedPackages,
  collection,
  shipmentCollection,
  steps = [],
  activeStep,
  pageName,
  // userActiveData,
}) {
  const { selectedRequest: userActiveData, selectedPackage: packageActiveData } = useSelector((state) => state.common);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeDataName, setActiveDataName] = useState(false);
  //   const [drawerForAddons, setDrawerOpenForAddOns] = useState(false);
  //   const [drawerForCustomIQ, setDrawerOpenForCustomIQ] = useState(false);
  //   const [labelForAddOnDrawer, setLabelForAddOnDrawer] = useState("");
  //   const [labelForCustomIQDrawer, setLabelForCustomIQDrawer] = useState("");
  const [packageItems, setPackageItems] = useState([]);
  const [editPackageData, setEditPackageData] = useState({});
  const [barcodeValue, setBarcodeValue] = useState("");
  const [slipValue, setSlipValue] = useState("");
  const [dateForSlip, setDateForSlip] = useState();
  const [consolidatePackageData, setConsolidatePackageData] = useState({});
  const slipRef = useRef();

  console.log(
    shipmentCollection,
    // selectedPackages,
    "shipmentCollection"
  );
  console.log("packageActiveData : ", packageActiveData, selectedPackages);
  console.log(userActiveData, "userActiveData xyzzzz");
  // console.log("pageName", pageName);

  const generateRandomBarcodeValue = () => {
    return Math.floor(100000000 + Math.random() * 900000000).toString();
  };

  const generateSlipNumber = () => {
    const randomNumber = Math.floor(100000 + Math.random() * 900000);
    return randomNumber;
  };

  useEffect(() => {
    setBarcodeValue(generateRandomBarcodeValue());
    setSlipValue(generateSlipNumber());
  }, []);

  useEffect(() => {
    if (
      packageActiveData?.arrivedAt !== null &&
      packageActiveData?.arrivedAt?.seconds
    ) {
      let date;
      if (packageActiveData?.arrivedAt?.seconds) {
        date = fromUnixTime(packageActiveData?.arrivedAt?.seconds);
      }

      setDateForSlip(format(new Date(date), "MM.dd.yyyy"));
    }
  }, [packageActiveData?.arrivedAt]);

  useEffect(() => {
    const fetchItemData = async () => {
      // if (
      //   (packageActiveData && Object.keys(packageActiveData).length === 0) ||
      //   (packageActiveData?.packageItemIds &&
      //     packageActiveData?.packageItemIds?.length === 0)
      // )
      //   return;
      const itemIdArray = packageActiveData?.packageItemIds;
      console.log(itemIdArray, "itemIdArray");
      const itemPromises =
        itemIdArray?.length > 0 &&
        itemIdArray?.map(async (itemId) => {
          if (!itemId) return null;
          const itemDocRef = doc(db, "items", itemId);
          const itemDocSnap = await getDoc(itemDocRef);

          if (itemDocSnap.exists()) {
            return itemDocSnap.data();
          }
        });

      const arr = itemPromises && (await Promise.all(itemPromises));
      // console.log(arr, "arr");
      setPackageItems(arr);
    };

    fetchItemData();
  }, [packageActiveData, packageActiveData?.packageItemIds]);

  const headCells = [
    { id: "no", label: "No" },
    { id: "name", label: "Item Name" },
    {
      id: "qty",
      label: "Qty",
      align: "right",
    },
    {
      id: "addons",
      label: "Add-ons",
      align: "right",
    },
    {
      id: "customsIQ",
      label: "CustomsIQ",
      align: "right",
    },
    {
      id: "documents",
      label: "Documents",
      align: "right",
    },
  ];

  function createData(
    no,
    item_img,
    itemId,
    name,
    fullName,
    subCategory,
    category,
    qty,
    addons,
    customsIQ,
    receipt_img,
    path
  ) {
    return {
      no,
      item_img,
      itemId,
      name,
      fullName,
      subCategory,
      category,
      qty,
      addons,
      customsIQ,
      receipt_img,
      path,
    };
  }

  const rows =
    packageItems.length > 0 &&
    packageItems?.map((item, index) => {
      return createData(
        index + 1,
        item?.itemImageURL,
        item?.id,
        item?.shortenedName,
        item?.name,
        item?.subcategory,
        item?.category,
        item?.quantity,
        item?.addonsList,
        item?.customiqRestrictions,
        item?.receiptImageURL,
        arrow
      );
    });
  const toggleDrawer = (packageActiveData) => {
    if (drawerOpen) {
      // Clear the drawer data when closing
      setEditPackageData({});
    } else {
      setEditPackageData(packageActiveData);
    }
    setDrawerOpen(!drawerOpen);
  };
  console.log(editPackageData, "editPackageData");

  const handleBackButton = () => {
    setActiveDataName(false);
  };

  const getUserName = async (userId) => {
    try {
      // Get the document reference for the userId
      const userDocRef = doc(db, "users", userId);

      // Fetch the document data
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        // Extract and return the 'name' field
        return userDoc.data()?.name || "No Name";
      } else {
        console.log("No such document!");
        return "No Name";
      }
    } catch (error) {
      console.error("Error fetching user name:", error);
      return "No Name";
    }
  };

  const handleDownload = async (data1, data2, data3, data4) => {
    try {
      let name;
      let sname = data3 ?? "No SerialNumber";
      const element = slipRef.current;

      try {
        const fetchedName = await getUserName(data4); // Await the function
        name = fetchedName ?? "No Name"; // Fallback to "No Name" if fetchedName is null or undefined
      } catch (error) {
        console.error("Error fetching user name:", error);
        name = "No Name"; // Fallback in case of any error
      }

      // Capture the element as a canvas
      const scale = 3; // Higher scale for better quality
      const canvas = await html2canvas(element, {
        scale,
        backgroundColor: "#fff", // Ensure background color
      });

      // Log the original canvas size
      const originalWidth = 945;
      const originalHeight = 591;
      console.log(
        `Original Width: ${originalWidth}, Original Height: ${originalHeight}`
      );

      // Create a new canvas with the same size
      const scaledCanvas = document.createElement("canvas");
      scaledCanvas.width = originalWidth;
      scaledCanvas.height = originalHeight;
      const context = scaledCanvas.getContext("2d");

      // Draw the original canvas onto the new canvas
      context.drawImage(canvas, 0, 0, originalWidth, originalHeight);

      // Convert the scaled canvas to a data URL
      const dataURL = scaledCanvas.toDataURL("image/png");

      // Create a link element and set it to download the image
      const link = document.createElement("a");
      link.href = dataURL;
      link.download = `${name}+${sname}.png`;

      // Append the link to the body to ensure it works across browsers
      document.body.appendChild(link);

      // Trigger the download by simulating a click
      link.click();

      // Remove the link after the download
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error generating image:", error);
    }
  };


  return (
    <>
      {!activeDataName && (
        <Box sx={{ paddingTop: "16px", paddingRight: "20px" }}>
          <Box sx={{ marginLeft: "20px", mb: "16px" }}>
            <Typography variant="h5">
              Tracking: {packageActiveData?.trackingNumber}
            </Typography>
          </Box>
          <Box sx={{ width: "100%" }}>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps?.map((step, index) => (
                <Step key={step.label}>
                  <StepLabel
                    StepIconProps={{
                      sx: {
                        "&.MuiStepIcon-root": {
                          color: "#FFF",
                          border: "1px solid",
                          borderRadius: "100%",
                          borderColor: "#959BA1",
                        },
                        "& .MuiStepIcon-text": {
                          fill: "#959BA1",
                          fontWeight: "bold",
                        },
                        "&.Mui-completed": {
                          color: "#38A34F",
                          borderColor: "#38A34F",
                        },
                        "&.Mui-active": {
                          color: "white",
                          border: "1px solid",
                          borderRadius: "100%",
                          borderColor: "#F68712",
                          "& .MuiStepIcon-text": {
                            fill: "#F68712",
                            color: "#FFF",
                            fontWeight: "bold",
                          },
                        },
                      },
                    }}
                  >
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "black",
                      }}
                    >
                      {step.label}
                    </span>
                    <br />
                    <span style={{ color: "#959BA1", fontSize: "16px" }}>
                      {step.date}
                    </span>
                  </StepLabel>
                  {index > 0 && (
                    <StepConnector
                      sx={{
                        "& .MuiStepConnector-line": {
                          borderWidth: "1px",
                          borderColor:
                            index < activeStep ? "#38A34F" : "#EDEDED", // Change color here
                        },
                      }}
                    />
                  )}
                </Step>
              ))}
            </Stepper>
          </Box>
          {/* <PackageStatus steps={steps} activeStep={activeStep} /> */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "20px",
              marginRight: "0px",
              backgroundColor: "#F9FAFC",
              border: "1px solid #E5E5E8",
              paddingY: "20px",
              paddingX: "40px",
              borderRadius: "4px",
            }}
          >
            <Box sx={{ display: "grid" }}>
              <label
                style={{
                  color: "#959BA1",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              >
                Serial Number
              </label>
              <label
                style={{
                  color: "#1C2630",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                {packageActiveData?.serialNumber || "-"}
              </label>
            </Box>
            <Box sx={{ display: "grid" }}>
              <label
                style={{
                  color: "#959BA1",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              >
                Value
              </label>
              <label
                style={{
                  color: "#1C2630",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                ${packageActiveData?.packageTotalAmount?.toFixed(2)}
              </label>
            </Box>
          </Box>
          {/* <SerialNumber
            SerialNumber={packageActiveData?.serialNumber || "-"}
            packageTotalAmount={packageActiveData?.packageTotalAmount}
            shipmentData={userActiveData}
            userClickHandler={userClickHandler}
            pageName={pageName}
            reloadDetails={reloadDetails}
          /> */}
          {/* <PackageDetails packageActiveData={packageActiveData} /> */}
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginLeft: "20px",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <Box sx={{ display: "grid", width: "30%" }}>
                <label
                  style={{
                    color: "#959BA1",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Merchant
                </label>
                <Box sx={{ display: "flex", marginTop: "5px" }}>
                  {packageActiveData?.brand &&
                    packageActiveData?.brand?.brandLogo !== "" ? (
                    <img
                      src={packageActiveData?.brand?.brandLogo}
                      alt="brandLogo"
                      style={{
                        width: "30px",
                        height: "20px",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    ""
                  )}
                  <label
                    style={{
                      color: "#1C2630",
                      fontWeight: "bold",
                      fontSize: "16px",
                      marginLeft: "5px",
                    }}
                  >
                    {packageActiveData?.brand?.brandName
                      ? packageActiveData?.brand?.brandName
                      : packageActiveData?.merchantCount
                        ? packageActiveData?.merchantCount
                        : "-"}
                  </label>
                </Box>
              </Box>
              <Box sx={{ display: "grid", width: "30%" }}>
                <label
                  style={{
                    color: "#959BA1",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Merchant Indicator
                </label>
                <label
                  style={{
                    color: "#1C2630",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginTop: "5px",
                  }}
                >
                  {packageActiveData?.merchantIndicator || "-"}
                </label>
              </Box>
              <Box sx={{ display: "grid", width: "30%" }}>
                <label
                  style={{
                    color: "#959BA1",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Nickname
                </label>
                <label
                  style={{
                    color: "#1C2630",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginTop: "5px",
                  }}
                >
                  {packageActiveData?.nickName || "-"}
                </label>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginLeft: "20px",
                marginTop: "40px",
                width: "100%",
              }}
            >
              <Box sx={{ display: "grid", width: "30%" }}>
                <label
                  style={{
                    color: "#959BA1",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Weight
                </label>
                <label
                  style={{
                    color: "#1C2630",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginTop: "5px",
                  }}
                >
                  {packageActiveData?.packageTotalWeight?.toFixed(2) || "-"}
                </label>
              </Box>
              <Box sx={{ display: "grid", width: "30%" }}>
                <label
                  style={{
                    color: "#959BA1",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Dimention
                </label>
                <label
                  style={{
                    color: "#1C2630",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginTop: "5px",
                  }}
                >
                  {/* {`${packageActiveData?.dimentionL || ""} X ${
              packageActiveData?.dimentionW || ""
            } X ${packageActiveData?.dimentionH || ""} ` || "-"} */}
                  {[
                    packageActiveData?.dimensionL,
                    packageActiveData?.dimensionW,
                    packageActiveData?.dimensionH,
                  ]
                    .filter(Boolean)
                    .join(" X ") || "-"}
                </label>
              </Box>
              <Box sx={{ display: "grid", width: "30%" }}>
                <label
                  style={{
                    color: "#959BA1",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Shelf ID
                </label>
                <label
                  style={{
                    color: "#1C2630",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginTop: "5px",
                  }}
                >
                  {packageActiveData?.shelfId || "-"}
                </label>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginLeft: "20px",
                marginTop: "40px",
                width: "100%",
              }}
            >
              <Box sx={{ display: "grid", width: "30%", whiteSpace: "nowrap" }}>
                <label
                  style={{
                    color: "#959BA1",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Expecting date
                </label>
                <label
                  style={{
                    color: "#1C2630",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginTop: "5px",
                  }}
                >
                  {packageActiveData?.expectedDate || "-"}
                </label>
              </Box>
              <Box sx={{ display: "grid", width: "30%" }}>
                <label
                  style={{
                    color: "#959BA1",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Ship on
                </label>
                <label
                  style={{
                    color: "#1C2630",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginTop: "5px",
                  }}
                >
                  {packageActiveData?.shipOn || "-"}
                </label>
              </Box>
              <Box sx={{ display: "grid", width: "30%", whiteSpace: "nowrap" }}>
                <label
                  style={{
                    color: "#959BA1",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Shipping method
                </label>
                <label
                  style={{
                    color: "#1C2630",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginTop: "5px",
                  }}
                >
                  {packageActiveData?.shipMethod || "-"}
                </label>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginLeft: "20px",
                marginTop: "40px",
                width: "100%",
              }}
            >
              <Box sx={{ display: "grid", width: "30%", whiteSpace: "nowrap" }}>
                <label
                  style={{
                    color: "#959BA1",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Suit Number
                </label>
                <label
                  style={{
                    color: "#1C2630",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginTop: "5px",
                  }}
                >
                  {packageActiveData?.suiteNumber || "-"}
                </label>
              </Box>
              <Box sx={{ display: "grid", width: "30%", whiteSpace: "nowrap" }}>
                <label
                  style={{
                    color: "#959BA1",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Warehouse Name
                </label>
                <label
                  style={{
                    color: "#1C2630",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginTop: "5px",
                  }}
                >
                  {userActiveData?.warehouseName || "-"}
                </label>
              </Box>
              <Box sx={{ display: "grid", width: "30%", whiteSpace: "nowrap" }}>
                <label
                  style={{
                    color: "#959BA1",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Address
                </label>
                <label
                  style={{
                    color: "#1C2630",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginTop: "5px",
                  }}
                >
                  {userActiveData?.routePartnerMainAddress?.addressLine1 || "-"}
                </label>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              justifyContent: "center",
              borderBottom: "1px solid #E5E5E8",
              paddingBottom: "30px",
              flexWrap: "wrap",
            }}
          >
            <Button
              variant="contained"
              disabled={!packageActiveData}
              sx={{
                backgroundColor: "white",
                color: "#481AA3",
                marginLeft: "10px",
                border: "1px solid #E5E5E8",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#481AA3",
                  backgroundColor: "white", // Remove border color on focus
                },
              }}
              onClick={() => toggleDrawer(packageActiveData)}
            >
              <img src={edit} alt="star" style={{ marginRight: "10px" }} />
              Edit Package Details
            </Button>
            <EditPackageDrawer
              pageName={pageName}
              editPackage={editPackageData}
              open={drawerOpen}
              onClose={toggleDrawer}
              collectionName={collection}
              shipmentCollectionName={shipmentCollection}
              shipmentData={userActiveData}
            />
            <Box sx={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
              <Slip
                ref={slipRef}
                name={
                  packageActiveData?.suiteNumber
                    ? packageActiveData?.name
                    : "No Name"
                }
                date={dateForSlip}
                suiteNumber={
                  packageActiveData?.suiteNumber
                    ? packageActiveData?.suiteNumber
                    : "No Suite"
                }
                packageId={
                  packageActiveData?.packageId && packageActiveData?.packageId
                }
                barcodeValue={
                  packageActiveData?.serialNumber
                    ? packageActiveData?.serialNumber
                    : barcodeValue
                }
              />
            </Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "white",
                color: "#481AA3",
                marginLeft: "10px",
                border: "1px solid #E5E5E8",
                boxShadow: "none",
                borderRadius: "4px",
                whiteSpace: "nowrap",
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#481AA3",
                  backgroundColor: "white", // Remove border color on focus
                },
              }}
              disabled={!packageActiveData?.serialNumber}
              onClick={() => {
                handleDownload(
                  packageActiveData?.suiteNumber,
                  packageActiveData?.name,
                  packageActiveData?.serialNumber,
                  packageActiveData?.userId
                )
              }
              }
            >
              <img src={slip} alt="slip" style={{ marginRight: "10px" }} />
              Receiving Slip
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                userActiveData?.labelUrl &&
                  window.open(userActiveData?.labelUrl, "_blank");
              }}
              disabled={
                pageName === "packages" ||
                pageName === "shippingRequest" ||
                pageName === "consolidateRequest" ||
                pageName === "shopping request" ||
                pageName === "expressRequest" ||
                pageName === "NoSuites" ||
                pageName === "Abandoned" ||
                !userActiveData?.labelUrl
              }
              sx={{
                backgroundColor: "white",
                color: "#481AA3",
                marginLeft: "10px",
                border: "1px solid #E5E5E8",
                boxShadow: "none",
                borderRadius: "4px",
                whiteSpace: "nowrap",
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#481AA3",
                  backgroundColor: "white", // Remove border color on focus
                },
              }}
            >
              <img src={slip} alt="slip" di style={{ marginRight: "10px" }} />
              Shipping Label
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                userActiveData?.customerDeclaration &&
                  window.open(userActiveData?.customerDeclaration, "_blank");
              }}
              disabled={
                pageName === "packages" ||
                pageName === "shippingRequest" ||
                pageName === "consolidateRequest" ||
                pageName === "shopping request" ||
                pageName === "expressRequest" ||
                pageName === "NoSuites" ||
                pageName === "Abandoned" ||
                !userActiveData?.customerDeclaration
              }
              sx={{
                backgroundColor: "white",
                color: "#481AA3",
                marginLeft: "10px",
                border: "1px solid #E5E5E8",
                boxShadow: "none",
                borderRadius: "4px",
                whiteSpace: "nowrap",
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#481AA3",
                  backgroundColor: "white", // Remove border color on focus
                },
              }}
            >
              <img src={slip} alt="slip" di style={{ marginRight: "10px" }} />
              Customer Declaration
            </Button>
          </Box>
          {packageActiveData?.serialNumber && (
            <SelectionTag packageActiveData={packageActiveData} />
          )}
          <Box
            sx={{
              borderBottom: "1px solid #E5E5E8",
              paddingBottom: "30px",
            }}
          >
            <Box sx={{ marginLeft: "20px", marginTop: "20px" }}>
              <h1
                style={{
                  textAlign: "left",
                  fontSize: " 26px",
                  fontWeight: "bold",
                }}
              >
                Package images
              </h1>
            </Box>
            <SimpleBar
              forceVisible="x"
              autoHide={true}
              style={{
                overflowX: "auto",
              }}
              className="custom-scrollbar"
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "20px",
                  marginTop: "20px",
                }}
              >
                {packageActiveData?.packageImages?.map((url, index) => (
                  <Box sx={{ marginRight: "20px" }}>
                    {url ? 
                        <img
                          src={url}
                          alt="package"
                          key={index}
                          style={{
                            height: "120px",
                            width: "120px",
                            minWidth: "120px",
                            minHeight: "120px",
                            maxWidth: "120px",
                            maxHeight: "120px",
                          }}
                          onClick={()=>{
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = 'image.jpg'; // You can change the filename if needed
                            a.click();
                          }}
                        />
                      : (
                      "-"
                    )}
                  </Box>
                ))}
              </Box>
            </SimpleBar>
          </Box>
          <Box sx={{ paddingBottom: "30px" }}>
            <Box sx={{ marginLeft: "20px", marginTop: "20px" }}>
              <h1
                style={{
                  textAlign: "left",
                  fontSize: " 26px",
                  fontWeight: "bold",
                }}
              >
                Item List
              </h1>
            </Box>
            {rows && (
              <CustomTable
                rows={rows}
                headCells={headCells}
                setActiveDataName={setActiveDataName}
                packageActiveData={packageActiveData}
                userActiveData={userActiveData}
                packageCollection={collection}
                shipmentCollection={shipmentCollection}
              />
            )}
          </Box>
        </Box>
      )}
      {activeDataName && (
        <AccordionViaTableRowName
          handleBack={handleBackButton}
          packageClickHandler={packageClickHandler}
          id={activeDataName}
          packageActiveData={packageActiveData}
          packageItems={packageItems}
          pageName={pageName}
          packageCollection={collection}
          shipmentCollection={shipmentCollection}
        />
      )}
    </>
  );
}

export default PackageTraking;
